/* Movimento leve do site novo da Lupi: o conteúdo das seções lupisite (.ls) entra ao rolar.
   Só transform/opacity; respeita "reduzir movimento"; o que já está na tela ao abrir não pisca. */
(function () {
  if (window.__lsMotion) return; window.__lsMotion = 1;
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduz || !('IntersectionObserver' in window)) return;
  var ALVOS = '.ls .ls-tit,.ls .ls-faixa__cab,.ls .ls-intro > *,.ls .ls-card,.ls .ls-cat,.ls .ls-hist__img,.ls .ls-hist__txt,.ls .ls-faixa__img,' +
    '.ls .ls-casa > *,.ls .ls-vant__i,.ls .ls-news__txt,.ls .ls-news form,.ls .ls-aj__card,.ls .ls-aj__bloco,.ls .ls-sob__m,.ls .ls-sob__p,' +
    '.ls .ls-land__txt,.ls .ls-land > div:last-child,.ls .ls-rod__top > *';
  function iniciar() {
    document.documentElement.classList.add('ls-motion');
    var alto = window.innerHeight;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, irmaos = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (c) { return c.classList.contains('ls-rv'); }) : [];
        var i = Math.max(0, irmaos.indexOf(el));
        el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
        el.classList.add('is-in');
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    var pendentes = [];
    document.querySelectorAll(ALVOS).forEach(function (el) {
      if (el.getBoundingClientRect().top < alto * 0.92) return; // já visível ao abrir: fica parado
      el.classList.add('ls-rv'); obs.observe(el); pendentes.push(el);
    });
    // rolagem rápida: o que passou direto sem ser visto também aparece (sem esperar voltar)
    var agendado = false;
    function varrer() {
      agendado = false; var h = window.innerHeight;
      pendentes = pendentes.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        if (el.getBoundingClientRect().top < h) { el.classList.add('is-in'); obs.unobserve(el); return false; }
        return true;
      });
      if (!pendentes.length) window.removeEventListener('scroll', aoRolar);
    }
    function aoRolar() { if (!agendado) { agendado = true; requestAnimationFrame(varrer); } }
    window.addEventListener('scroll', aoRolar, { passive: true });
    document.querySelectorAll('.ls-topo__f img').forEach(function (img) {
      var f = function () { img.classList.add('is-in'); };
      if (img.complete) requestAnimationFrame(f); else img.addEventListener('load', f, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
